import React from "react";
import { TextInput } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import { useChannelInfoOptions } from "./ChannelContext";

const EditChannelName = () => {
  const { channelName, handleChannelInfoChange } = useChannelInfoOptions();
  const { t } = useI18n(["common", "announcement"]);

  const handleOnTextChange = e => {
    handleChannelInfoChange({ channelName: e.target.value });
  };

  return (
    <TextInput
      label={`${t("common:name")} *`}
      name="name"
      size={"medium"}
      placeholder={t("common:enter_with_label", {
        label: t("common:name"),
      })}
      value={channelName}
      required
      onChange={handleOnTextChange}
      dsVersion="2.0"
    />
  );
};

export default EditChannelName;
